import * as React from "react";
import AuthContext from '../controllers/auth/AuthContext';
import { MainAuthProvider } from "../controllers/auth/AuthController";
import { 
  useNavigate, 
  useLocation,
  Navigate, 
} from "react-router-dom";
import { useAuth } from "../controllers/auth/UseAuth";

function AuthProvider({ children }: { children: React.ReactNode }) {
    let [user, setUser] = React.useState<any>(null);
  
    let signin = (newUser: string, callback: VoidFunction) => {
      return MainAuthProvider.signin(() => {
        setUser(newUser);
        callback();
      });
    };
  
    let signout = (callback: VoidFunction) => {
      return MainAuthProvider.signout(() => {
        setUser(null);
        callback();
      });
    };
  
    let value = { user, signin, signout };
  
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
  }

  function AuthStatus() {
    let auth = useAuth();
    let navigate = useNavigate();
  
    return (
      <p>
      </p>
    );
  }
  
  function RequireAuth({ children }: { children: JSX.Element }) {
    let auth = useAuth();
    let location = useLocation();
  
    if (!auth.user) {
      return <Navigate to="/" state={{ from: location }} />;
    }
  
    return children;
  }

export {
  AuthProvider, 
  AuthStatus, 
  RequireAuth 
};